import React, { useCallback, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Card, Typography } from 'antd'
import bfaLogo from 'src/assets/images/bfa-logo.png'
import backgroundImage from 'src/assets/images/background-page.png'
import userImage from 'src/assets/images/user-01.png'
import { colorText } from 'src/app/themes/primaryThemeDefault'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { TOKEN_FROM_EMAIL } from '../../constants/searchParams.constants'
import { ssoLogin } from '../../services/AuthenticationService'
import { IDefaultResponse, ISSOLogin } from '../../models/auth.model'
import { logIn } from 'src/app/store/auth'
import dayjs from 'dayjs'
import { SERVER_STATUS_CODES } from '../../constants/serverResponseStatusCodes.constants'
import { defaultHomePage } from '../../constants/app.constants'
import { useDispatch } from 'react-redux'
import 'src/styles/_three_dot_loading.scss'
import '../access-denied-page/logout.scss'

const SSORedirecting: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { pathname, search } = useLocation()
  const dispatch = useDispatch()
  const token = useMemo(() => searchParams.get(TOKEN_FROM_EMAIL), [searchParams])

  const handleErrorResponse = useCallback(
    (err: IDefaultResponse<any>) => {
      switch (err?.statusCode) {
        case SERVER_STATUS_CODES.PPI1SSO_USER_NOT_FOUND:
          navigate('/sso-user-not-found')
          break

        case SERVER_STATUS_CODES.PPI3SSO_LOCK_USER:
          navigate('/sso-locked-user')
          break

        case SERVER_STATUS_CODES.PPI4SSO_USER_IS_INACTIVE:
          navigate('/sso-inactive-user')
          break

        case SERVER_STATUS_CODES.PPI9SSO_EXCEPTION:
          navigate('/sso-error-occured')
          break
        default:
          alert('Unknown error occurred!')
          break
      }
    },
    [navigate],
  )

  useEffect(() => {
    if (token) {
      const payload: ISSOLogin = { token }
      ssoLogin(payload).then(
        (res: any) => {
          if (res?.data) {
            const dataAuth = res?.data
            dispatch(
              logIn({ ...dataAuth, accessTokenExpiresAt: dayjs().add(dataAuth.accessExpiresIn, 'seconds').format() }),
            )
            navigate(defaultHomePage)
          }
        },
        (err: IDefaultResponse<any>) => {
          handleErrorResponse(err)
        },
      )
    }
  }, [navigate, pathname, search, dispatch, token, handleErrorResponse])

  return (
    <div
      className='page-container'
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
      }}
    >
      <img className='page-logo' src={bfaLogo} alt='logo' />

      <Card className='page-card' bordered={false}>
        <img src={userImage} alt='inactive-user-image' />

        <Typography.Text style={{ fontSize: 16, textAlign: 'center', color: colorText }}>
          <div>
            {t('common:sso_redirecting_description')}
            <span className='loading'>...</span>
          </div>
        </Typography.Text>
      </Card>
    </div>
  )
}

export default SSORedirecting
